import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';

export const path = '/personal-registry';

// Loadable вызывается на уровне модуля, а не в теле компонента: каждый вызов возвращает
// НОВЫЙ тип компонента, а новый тип React монтирует заново вместо обновления. Router
// перерисовывает поддерево на любое изменение адреса, включая строку запроса, поэтому
// состояние реестра в URL приводило бы к размонтированию страницы на каждый ввод —
// поле поиска теряло фокус, а выделение сбрасывалось.
const PersonalRegistryPage = Loadable({
  loader: () => import('./page'),
  loading: LoadableLoading,
});

const PagePersonalRegistry: React.FC = (props) => <PersonalRegistryPage {...props} />;

export default PagePersonalRegistry;
